import React from 'react';
import PropTypes from 'prop-types';
import { waFetch, responseAsJson } from 'wa.admin-ui.fetch';

import { processPageLink } from '../../../utils/url-utils';

import WebsiteTab from './components/website-tab';
import SitePageTab from './components/site-page-tab';
import EventTab from './components/event-tab';
import TabSwitcher from './components/tab-switcher';
import Settings from './components/settings';

import LocalizationConsumer from '../../../l10n/localization-context';
import tabs from '../../../constants/tabs';

import replaceEventId from './replace-event-id';

import './insert-link.less';

export const isEventLinksToDetailsValue = 'isEventLinksToDetails';

class InsertLink extends React.Component
{
  static propTypes =
  {
    isSimpleView: PropTypes.bool,
    tooltip: PropTypes.string.isRequired,
    activeSlideShowImage: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    previewImage: PropTypes.string.isRequired,
    onUrlChange: PropTypes.func.isRequired,
    onLinkTextChange: PropTypes.func.isRequired,
    onTooltipChange: PropTypes.func.isRequired,
    onOpenInNewWindowChange: PropTypes.func.isRequired,
    onLinkStyleChange: PropTypes.func.isRequired,
    openInNewWindow: PropTypes.bool.isRequired,
    isLinkTextEditable: PropTypes.bool.isRequired,
    baseDetailsUrlTemplate: PropTypes.string.isRequired,
    baseRegistrationUrlTemplate: PropTypes.string.isRequired,
    eventsEndpoint: PropTypes.string.isRequired,
    pagesStructureEndpoint: PropTypes.string.isRequired,
    isLinkTextSectionHidden: PropTypes.bool.isRequired,
    isLinkStyleSectionHidden: PropTypes.bool.isRequired,
    isLinkOptionsHidden: PropTypes.bool.isRequired,
    isTooltipOptionHidden: PropTypes.bool.isRequired,
    linkStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
    linkStyle: PropTypes.string.isRequired,
    linkStyleIframeSrc: PropTypes.string.isRequired,
    isSlideShowInsertLinksMode: PropTypes.bool.isRequired,
    slideShowImageDescription: PropTypes.string.isRequired,
    onSlideShowImageDescriptionChange: PropTypes.func.isRequired
  };

  constructor(props)
  {
    super(props);

    this.state = {
      activeTab: tabs.WEBSITE,
      sitePageData: null,
      eventsData: null,
      selectedEventId: null,
      isSitePageTabMounted: false,
      isSitePageDataLoading: false,
      isSitePageDataLoadingError: false,
      isEventsTabMounted: false,
      isEventsDataLoading: false,
      isEventsDataLoadingError: false,
      isEventLinksToDetails: true,
      isEventRegistrationFormDisabled: false
    };
  }


  setEventUrl = (eventId, setToRegisterForm = false) =>
  {
    // @todo remove for replaceEventId
    const { onUrlChange, baseDetailsUrlTemplate, baseRegistrationUrlTemplate } = this.props;

    onUrlChange((setToRegisterForm ? baseRegistrationUrlTemplate : baseDetailsUrlTemplate).replace('{0}', eventId));
  };

  handleEventDestinationChange = (e) =>
  {
    const { selectedEventId } = this.state;
    const { onUrlChange, baseDetailsUrlTemplate, baseRegistrationUrlTemplate } = this.props;

    const isEventLinksToDetails = e.target.value === isEventLinksToDetailsValue;
    const template = isEventLinksToDetails ? baseDetailsUrlTemplate : baseRegistrationUrlTemplate;

    this.setState({ isEventLinksToDetails });

    if (!selectedEventId) return;

    onUrlChange(replaceEventId(template, selectedEventId));
  };

  handleTabChange = tab => () =>
  {
    const { activeTab } = this.state;

    if (tab === activeTab) return;

    this.setState({ activeTab: tab });
  };

  handleSiteLinkClick = (link) =>
  {
    const { onLinkTextChange, onUrlChange } = this.props;
    const { name, url } = link;

    this.setState({
      selectedEventId: null
    });

    onLinkTextChange(name);
    onUrlChange(processPageLink(url));
  };

  handleSetRegistratonFormOption = (setToForm) =>
  {
    this.setState({ isEventLinksToDetails: !setToForm });
  };

  handleEventClick = (event) =>
  {
    const { onLinkTextChange } = this.props;
    const {
      id,
      title,
      registrationEnabled,
      isEventPassed
    } = event;

    const { adminOnly } = event.accessControl.permissions;

    this.setState({
      selectedEventId: id,
      isEventLinksToDetails: true,
      isEventRegistrationFormDisabled: !registrationEnabled || adminOnly || isEventPassed
    });

    onLinkTextChange(title);

    this.setEventUrl(id);
  };

  handleSitePageTabMounted = () =>
  {
    const { isSitePageTabMounted } = this.state;

    if (!isSitePageTabMounted)
    {
      this.setState({ isSitePageTabMounted: true });
      this.fetchSitePageTabData();
    }
  };

  handleEventTabMounted = () =>
  {
    const { isEventsTabMounted } = this.state;

    if (!isEventsTabMounted)
    {
      this.setState({ isEventsTabMounted: true });
      this.fetchEventTabData();
    }
  };

  fetchSitePageTabData = () =>
  {
    const { pagesStructureEndpoint } = this.props;

    this.setState({ isSitePageDataLoading: true });

    waFetch(pagesStructureEndpoint)
      .then(responseAsJson)
      .then((payload) =>
      {
        this.setState(
          {
            isSitePageDataLoading: false,
            sitePageData: payload
          });
      })
      .catch(() =>
      {
        this.setState({ isSitePageDataLoadingError: true });
      });
  };

  fetchEventTabData = () =>
  {
    const { eventsEndpoint } = this.props;

    this.setState({ isEventsDataLoading: true });

    waFetch(eventsEndpoint)
      .then(responseAsJson)
      .then((payload) =>
      {
        this.setState(
          {
            isEventsDataLoading: false,
            eventsData: payload
          });
      })
      .catch(() =>
      {
        this.setState({ isEventsDataLoadingError: true });
      });
  };


  render()
  {
    const {
      activeTab,
      sitePageData,
      eventsData,
      isEventLinksToDetails,
      isEventRegistrationFormDisabled,
      isSitePageDataLoading,
      isSitePageDataLoadingError,
      isEventsDataLoading,
      isEventsDataLoadingError
    } = this.state;

    const {
      isSimpleView,
      isSlideShowInsertLinksMode,
      slideShowImageDescription,
      onSlideShowImageDescriptionChange,
      onUrlChange,
      onLinkTextChange,
      onTooltipChange,
      onOpenInNewWindowChange,
      onLinkStyleChange,
      tooltip,
      linkText,
      url,
      previewImage,
      openInNewWindow,
      isLinkTextEditable,
      isLinkTextSectionHidden,
      isLinkStyleSectionHidden,
      isTooltipOptionHidden,
      isLinkOptionsHidden,
      linkStyles,
      linkStyle,
      linkStyleIframeSrc,
      activeSlideShowImage
    } = this.props;

    const currentTab =
    {
      [tabs.WEBSITE]: (
        <WebsiteTab
          activeTab={activeTab}
          url={url}
          onChange={onUrlChange}
        />),
      [tabs.PAGE]: (
        <SitePageTab
          url={url}
          key={activeSlideShowImage}
          isSlideShowInsertLinksMode={isSlideShowInsertLinksMode}
          onComponentMount={this.handleSitePageTabMounted}
          onSiteLinkClick={this.handleSiteLinkClick}
          sitePageData={sitePageData}
          isSitePageDataLoading={isSitePageDataLoading}
          isSitePageDataLoadingError={isSitePageDataLoadingError}
        />
      ),
      [tabs.EVENTS]: (
        <EventTab
          url={url}
          key={activeSlideShowImage}
          isSlideShowInsertLinksMode={isSlideShowInsertLinksMode}
          onComponentMount={this.handleEventTabMounted}
          onEventClick={this.handleEventClick}
          setRegistratonFormOption={this.handleSetRegistratonFormOption}
          eventsData={eventsData}
          isEventsDataLoading={isEventsDataLoading}
          isEventsDataLoadingError={isEventsDataLoadingError}
        />
      )
    }[activeTab];

    return (
      <div className="-wa-edit-controls__insert-link-container">
        <table className="-wa-edit-controls__tree-and-settings-table">
          <tbody>
            <tr className="-wa-edit-controls__tree-and-settings-table-tr">
              <td className="-wa-edit-controls__tree-container">
                <div className="-wa-edit-controls__tree">
                  {isSimpleView ?
                    (
                      <>
                        <div className="-wa-edit-controls__main-header">
                          <LocalizationConsumer id="insert-link-dialog.main-section-name" />
                        </div>
                        <WebsiteTab
                          activeTab={tabs.WEBSITE}
                          url={url}
                          onChange={onUrlChange}
                        />
                      </>
                    ) :
                    (
                      <>
                        <TabSwitcher activeTab={activeTab} onChange={this.handleTabChange}/>
                        <div className="-wa-edit-controls__tabs-container">
                          {currentTab}
                        </div>
                      </>
                    )}
                </div>
              </td>
              <td className="-wa-edit-controls__settings-container">
                <Settings
                  isSlideShowInsertLinksMode={isSlideShowInsertLinksMode}
                  onEventDestinationChange={this.handleEventDestinationChange}
                  onSlideShowImageDescriptionChange={onSlideShowImageDescriptionChange}
                  onLinkTextChange={onLinkTextChange}
                  onTooltipChange={onTooltipChange}
                  onOpenInNewWindowChange={onOpenInNewWindowChange}
                  onLinkStyleChange={onLinkStyleChange}
                  tooltip={tooltip}
                  slideShowImageDescription={slideShowImageDescription}
                  linkText={linkText}
                  activeTab={activeTab}
                  openInNewWindow={openInNewWindow}
                  isEventLinksToDetails={isEventLinksToDetails}
                  isEventRegistrationFormDisabled={isEventRegistrationFormDisabled}
                  isLinkTextEditable={isLinkTextEditable}
                  previewImage={previewImage}
                  isLinkTextSectionHidden={isLinkTextSectionHidden}
                  isLinkStyleSectionHidden={isLinkStyleSectionHidden}
                  isTooltipOptionHidden={isTooltipOptionHidden}
                  isLinkOptionsHidden={isLinkOptionsHidden}
                  linkStyles={linkStyles}
                  linkStyle={linkStyle}
                  linkStyleIframeSrc={linkStyleIframeSrc}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default InsertLink;